import type { PriceBookSheetView } from '@/document-render/domain/priceBook/buildPriceBookBySheetView';
import { PriceBookRateRow } from './PriceBookRateRow';
import { PriceBookRateTable } from './PriceBookRateTable';
import { HIDDEN_OPACITY, SHEET_HEADING_STYLE, SHEET_NOTE_STYLE } from './priceBookSheetStyles';

/** A read-only rate sheet: "name · jobType" heading, flat note, then its subsections. */
export function PriceBookSheetGroup({ sheet, headerFontSize }: { sheet: PriceBookSheetView; headerFontSize?: number | string }) {
  return (
    <div data-price-book-sheet-id={sheet.sheetId} style={{ opacity: sheet.dimmed ? HIDDEN_OPACITY : undefined }}>
      <div style={SHEET_HEADING_STYLE}>{sheet.heading}</div>
      {sheet.flatNote ? <div style={SHEET_NOTE_STYLE}>{sheet.flatNote}</div> : null}
      {sheet.subsections.map((subsection) => (
        <PriceBookRateTable
          key={subsection.key}
          subsection={subsection}
          headerFontSize={headerFontSize}
          renderRow={(row) => <PriceBookRateRow key={row.id} row={row} />}
        />
      ))}
    </div>
  );
}
